import FilterWidgetModule from './filter-widget.module'

export default FilterWidgetModule
